import React from "react";
import { offer } from "../data/offer";
export function PromoBar() {
  return <div className="sticky top-0 z-40 w-full bg-navy text-white shadow-[0_2px_12px_rgba(11,24,56,0.25)]" data-id="element-241" data-mp="89p1vw9sy8fc">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-0.5 px-4 py-2 text-center sm:flex-row sm:gap-3 sm:py-2.5" data-id="element-242" data-mp="3ifbuukcd32x">
        <p className="font-display text-[11px] font-extrabold uppercase tracking-[0.12em] text-gold sm:text-xs" data-id="element-243" data-mp="3uogrlgf94kuw">
          Special Introductory Offer — Save {offer.savings} Today!
        </p>
        <span aria-hidden="true" className="hidden h-4 w-px bg-white/25 sm:block" data-id="element-244" data-mp="3lnik2o5ltv7k" />
        <p className="text-[13px] font-medium text-white/85 sm:text-sm" data-id="element-245" data-mp="3gqa1wnkghr6b">
          Regular Price <s className="text-white/60" data-id="element-246" data-mp="3bqxi6bovt07y">{offer.regularPrice}</s> — Now Only{" "}
          <strong className="font-display text-base font-extrabold text-white" data-id="element-247" data-mp="1exlxwbzzmzph">{offer.price}</strong>
        </p>
      </div>
    </div>;
}